module.exports = __webpack_public_path__ + "static/media/Heroku.2a004ad1.svg";